import React from 'react';

import { ROUTES } from '@elara/client-core/constants';

import { Button, Logo } from '#ui/index.js';
import { LinkButton } from '#views/Router.js';

interface RouteErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

export function RouteErrorFallback({ error, resetErrorBoundary }: RouteErrorFallbackProps) {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background px-4">
      <div className="mx-auto max-w-sm text-left">
        <Logo variant="symbol" width={24} />
        <h1 className="mt-4 text-2xl font-semibold font-display">Something went wrong</h1>
        <p className="mt-2 mb-6 text-muted-foreground">
          We encountered an error while loading this page. This might be a temporary issue.
        </p>

        {process.env.NODE_ENV === 'development' && (
          <details className="mb-6 text-left">
            <summary className="cursor-pointer text-sm text-muted-foreground hover:text-foreground">
              Error Details (Development)
            </summary>
            <pre className="mt-2 rounded bg-muted p-3 text-xs text-muted-foreground overflow-auto">
              {error.message}
              {error.stack && `\n\n${error.stack}`}
            </pre>
          </details>
        )}

        <div className="flex flex-col gap-3 sm:flex-row">
          <Button onClick={resetErrorBoundary}>Try again</Button>
          <LinkButton to={ROUTES.HOME} variant="outline">
            Home
          </LinkButton>
        </div>
      </div>
    </div>
  );
}
